import { formatLocalYYYYMMDD } from './dateUtils';

/** Nights occupied for availability: check-in through night before check-out. */
export function expandStayDates(checkIn: Date, checkOut: Date): string[] {
  const dates: string[] = [];
  const current = new Date(checkIn);
  const end = new Date(checkOut);
  while (current < end) {
    dates.push(formatLocalYYYYMMDD(current));
    current.setDate(current.getDate() + 1);
  }
  return dates;
}
